import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HookFunctions } from 'app/generic/hookFunctions';
import { NewModalService } from 'app/generic/new-modal/new-modal.service';
import { CusSatCommunicationService } from 'app/components/cus-sat/cus-sat-communication.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {

  @ViewChild('linkModal') linkModal: ElementRef;
  adlink = `${environment.publicSiteBase}/admin/`;

  constructor(
    public router: Router,
    private newModal: NewModalService,
    private modalService: NgbModal,
    private cusSatCommunication: CusSatCommunicationService
  ) { }

  ngOnInit(): void {
  }

  routeTo(path: any) {
    this.router.navigate([path]);
  }


  openModalLinks(){
    this.modalService.open(this.linkModal, { size: 'lg', 
      backdrop: 'static', 
      keyboard: false,  });
  }

  closeSingleModal(modal) {
    modal.close('close');
  }

  openCusSat() {
    // Usa il servizio di comunicazione per aprire il componente cus-sat
    this.cusSatCommunication.openFeedback();
  }

}
